import React from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { CardScreen } from "./screens/CardScreen.es";
import UpdateCard from "./components/newcoordination/UpdateCoordinationSettings";

function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/" component={CardScreen} />
          <Route exact path="/detail/:detailCoordinationId" component={UpdateCard} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
